import {createTheme} from '@mui/material';

export const darkTheme = createTheme({

  custom : {
    mode: 'dark',
    groupCard : 'linear-gradient(171.11deg, #0F2540 0%, #091626 100%)',
    feedbackColor: '#FFFFFF',
    groupCardShadow: '0px 10px 30px rgba(255, 255, 255, 0.07)',

  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1920
    }
  },
  components: {

    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: "#ccc"
        },
        track: {
          backgroundColor: "#fff"
        }
      }

    },
    MuiDialog: {
      styleOverrides: {

        paper: {
          boxShadow: "5px -5px 25px 25px rgba(100, 116, 139, 0.4)"
        }
      }
    },

    MuiAlert: {
      styleOverrides: {
        outlinedSuccess: {
          border: '1px solid #65748B',
          backgroundColor: 'rgba(0,0,0,0)',
          color: 'white'
        },
        standardSuccess: {
          border: '1px solid #65748B',
          backgroundColor: 'rgba(0,0,0,0)',
          color: 'white'
        },
        standardError: {
          border: '1px solid #65748B',
          backgroundColor: 'rgba(0,0,0,0)',
          color: 'white'
        },
        standardWarning: {
          backgroundColor: 'rgba(0,0,0,0)',
          border: '1px solid #65748B',
          color: 'white'
        },
        standardInfo: {
          border: '1px solid #65748B',
          backgroundColor: 'rgba(0,0,0,0)',
          color: 'white'
        }
      }
    },

    MuiCard: {
      styleOverrides : {
        root : {
          background: "#1F2937",
          borderRadius: "12px",
          boxShadow: "0px 10px 30px rgba(36, 43, 56, 0.07)"
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {

        outlined: {
          color: "#fff"
        },

        root: {
          textTransform: 'none'
        },
        sizeSmall: {
          padding: '6px 16px'
        },
        sizeMedium: {
          padding: '8px 20px'
        },
        sizeLarge: {
          padding: '11px 24px'
        },
        textSizeSmall: {
          padding: '7px 12px'
        },
        textSizeMedium: {
          padding: '9px 16px'
        },
        textSizeLarge: {
          padding: '12px 16px'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        outlined: {
          color: '#fff'
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '32px 24px',
          '&:last-child': {
            paddingBottom: '32px'
          }
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {
          variant: 'h6'
        },
        subheaderTypographyProps: {
          variant: 'body2'
        }
      },
      styleOverrides: {
        root: {
          paddingTop: '20px'
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
          margin: 0,
          padding: 0
        },
        html: {
          MozOsxFontSmoothing: 'grayscale',
          WebkitFontSmoothing: 'antialiased',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100%',
          width: '100%'
        },
        body: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          minHeight: '100%',
          width: '100%'
        },
        '#__next': {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          height: '100%',
          width: '100%'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: '#E6E8F0'
        }
      }
    },

    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd).Mui-selected': {
            backgroundColor: "rgb(50, 125, 217,0.4)",
          },
          '&:nth-of-type(even).Mui-selected': {
            backgroundColor: "rgb(50, 125, 217,0.4)",
          },
          '&:nth-of-type(odd)': {
            backgroundColor: "rgba(0,0,0,0)"

          },
          '&:nth-of-type(even)': {
            backgroundColor: "rgba(255,255,255,0.08)",
          },
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
          color: '#D1D5DB'
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {


          borderBottom: '1px solid rgba(255,255,255,0.1)',
          '& .MuiTableCell-root': {
            borderBottom: 'none',
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: 1,
            letterSpacing: 0.5,
            textTransform: 'uppercase'
          },
          '& .MuiTableCell-paddingCheckbox': {
            paddingTop: 4,
            paddingBottom: 4
          }
        }
      }
    }
  },
  palette: {
    neutral: {
      100: '#F3F4F6',
      200: '#E5E7EB',
      300: '#D1D5DB',
      400: '#9CA3AF',
      500: '#6B7280',
      600: '#4B5563',
      700: '#374151',
      800: '#1F2937',
      900: '#111827'
    },
    action: {
      active: '#6B7280',
      focus: 'rgba(55, 65, 81, 0.12)',
      hover: 'rgba(55, 65, 81, 0.04)',
      selected: 'rgba(55, 65, 81, 0.08)',
      disabledBackground: 'rgba(55, 65, 81, 0.12)',
      disabled: 'rgba(248,246,246,0.26)'
    },
    background: {
      default: '#091626',
      paper: '#060F19'
    },
    divider: 'rgba(0,0,0,0)',
    primary: {

      main: 'rgb(50, 125, 217)',
      light: '#43C6B7',
      dark: '#327dd9',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#10B981',
      light: '#3FC79A',
      dark: '#0B815A',
      contrastText: '#FFFFFF'
    },
    success: {
      main: '#5048E5',
      light: '#828DF8',
      dark: '#3832A0',
      contrastText: '#FFFFFF'
    },
    info: {
      main: '#2196F3',
      light: '#64B6F7',
      dark: '#0B79D0',
      contrastText: '#FFFFFF'
    },
    warning: {
      main: '#FFB020',
      light: '#FFBF4C',
      dark: '#B27B16',
      contrastText: '#FFFFFF'
    },
    error: {
      main: '#FF0066',
      light: '#DA6868',
      dark: '#922E2E',
      contrastText: '#FFFFFF'
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#65748B',
      disabled: 'rgba(55, 65, 81, 0.48)'
    }
  },
  shape: {
    borderRadius: 8
  },
  shadows: [
    'none',
    '0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)',
    '0px 1px 2px rgba(255, 255, 255, 0.1)',
    '0px 1px 4px rgba(255, 255, 255, 0.1)',
    '0px 1px 5px rgba(255, 255, 255, 0.1)',
    '0px 1px 6px rgba(255, 255, 255, 0.1)',
    '0px 2px 6px rgba(255, 255, 255, 0.1)',
    '0px 3px 6px rgba(255, 255, 255, 0.1)',
    '0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(255, 255, 255, 0.1)',
    '0px 5px 12px rgba(255, 255, 255, 0.1)',
    '0px 5px 14px rgba(255, 255, 255, 0.1)',
    '0px 5px 15px rgba(255, 255, 255, 0.1)',
    '0px 6px 15px rgba(255, 255, 255, 0.1)',
    '0px 7px 15px rgba(255, 255, 255, 0.1)',
    '0px 8px 15px rgba(255, 255, 255, 0.1)',
    '0px 9px 15px rgba(255, 255, 255, 0.1)',
    '0px 10px 15px rgba(255, 255, 255, 0.1)',
    '0px 12px 22px -8px rgba(100, 116, 139, 0.25)',
    '0px 13px 22px -8px rgba(100, 116, 139, 0.25)',
    '0px 14px 24px -8px rgba(100, 116, 139, 0.25)',
    '0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)',
    '0px 25px 50px rgba(100, 116, 139, 0.25)'
  ],
  typography: {
    button: {
      fontSize: '1rem',
      fontWeight: 500
    },
    fontFamily: 'Poppins',
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.5
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.57
    },
    subtitle1: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.75
    },
    subtitle2: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: 1.57
    },
    overline: {
      fontSize: '1.00rem',
      fontWeight: 500,
      letterSpacing: '0.5px',
      lineHeight: 2.5,
      textTransform: 'uppercase'
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: 1.66
    },
    h1: {
      fontWeight: 700,
      fontSize: '3.5rem',
      lineHeight: 1.375
    },
    h2: {
      fontWeight: 700,
      fontSize: '3rem',
      lineHeight: 1.375
    },
    h3: {
      fontWeight: 700,
      fontSize: '2.25rem',
      lineHeight: 1.375
    },
    h4: {
      fontWeight: 700,
      fontSize: '2rem',
      lineHeight: 1.375
    },
    h5: {
      fontWeight: 500,
      fontSize: '1.5rem',
      lineHeight: 1.375
    },
    h6: {
      fontWeight: 500,
      fontSize: '1.125rem',
      lineHeight: 1.375
    }
  }
});
